<main class="settings">
  <div class="content">
    <section class="header">
      <h1>Settings</h1>
      <p>{{ currentRigtsholderName}}</p>
      <div class="tabs">
        <div class="tabswrap">
          <div class="tab-buttons">
            <button class="tab-button" [class.active]="activeTab === 'members'" (click)="setActiveTab('members')">
              User Management
            </button>
            <button class="tab-button" [class.active]="activeTab === 'settings'" (click)="setActiveTab('settings')" *ngIf="!isAdmin || (isAdmin && !isCurrentBoardSameAsTargetedBoard)">
              Company settings
            </button>
            <button class="tab-button"  [class.active]="activeTab === 'superadmin'" (click)="setActiveTab('superadmin')"
              *ngIf="this.isAdmin && !isCurrentBoardSameAsTargetedBoard">
              Superadmin settings
            </button>
            <div class="slider" [ngStyle]="sliderStyle"></div>
            <div class="invite">
              <button id="inviteusers" class="btn green" (click)="openInviteModal()">
                <img class="left" src="/assets/icons/person-add-white.svg">
                Invite user
              </button>
            </div>
          </div>
        </div>
        <div class="tab-contents">
          <div class="tab-content" [class.active]="activeTab === 'members'">
            <app-members *ngIf="activeTab === 'members'" [roles]="roles"></app-members>
          </div>
          <div id="settings" class="tab-content" [class.active]="activeTab === 'settings'">
            <app-company-settings *ngIf="activeTab === 'settings'"></app-company-settings>
          </div>
          <div id="superadmin" class="tab-content"  [class.active]="activeTab === 'superadmin'">
            <app-super-admin-settings *ngIf="activeTab === 'superadmin'"></app-super-admin-settings>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>
<div class="modal" [class.show]="isInviteModalOpen" id="inviteModal">
  <form [formGroup]="inviteForm">
    <div class="mw defaultmodal">

      <div class="mwrap">
        <div class="topbar">
          <span>
            <h3>Send invitation</h3>
            <p>Invite a new team member to join your account.</p>
          </span>

          <img data-action="closeuserinvite" src="/assets/icons/x.svg" alt="Close" (click)="closeInviteModal()">
        </div>
        <div class="mc">


          <div class="row">
            <div class="inputs">
              <div class="input">
                <label>E-mail address</label>
                <input id="adduserinvite" formControlName="email" type="email" placeholder="Add e-mailaddress..." autocomplete="off"
                  autofocus />
                <div *ngIf="
                      inviteForm.controls.email.invalid &&
                      inviteForm.controls.email.touched
                    ">
                  <small class="text-danger" *ngIf="inviteForm.controls.email.errors!.required">Email is
                    required.</small>
                  <small class="text-danger" *ngIf="inviteForm.controls.email.errors!.email">Please enter a valid
                    email.</small>
                </div>

              </div>
              <p class="select">Select type of account</p>

              <ul>
                <li class="radio-wrapper" *ngFor="let role of roles; let first = first">
                  <label>
                    <input type="radio" class="custom-radio" formControlName="userRole" [value]="role.id">
                    <div>
                      <h3>{{ role.name }}</h3>
                      <ul>
                        <li *ngIf="role.name === 'Superadmin'">Full access to all settings and user management</li>
                        <li *ngIf="role.name === 'Label Admin'">Full access</li>
                        <li *ngIf="role.name === 'Label User'">Full access, excluding user management and settings</li>
                        <li
                          *ngIf="role.name !== 'Superadmin' && role.name !== 'Label Admin' && role.name !== 'Label User'">
                          Standard access based on role permissions
                        </li>
                      </ul>
                    </div>
                  </label>
                </li>
              </ul>

            </div>
          </div>

          <hr class="dashed" />

          <button class="btn green" id="send-invite" (click)="sendInvitation()" [disabled]="inviteForm.invalid">Send
            invitation</button>
        </div>
      </div>
    </div>
  </form>
</div>
